

const Loading = (props: any) =>{
    return(
        <>
            {props?.isCardList && <div className={`2xl:px-28 xl:px-22 md:px-8 px-3 grid grid-cols-1 md:grid-cols-2 md:gap-x-4 lg:grid-cols-3 lg:gap-x-16 gap-y-24 ${props?.classes}`}>
                {Array.from({length: props?.itemsPerPage}, (index:any)=>{
                return(
                        <div  role="status" key={index} className={`p-4 md:max-w-sm border border-gray-200 shadow animate-pulse md:p-6  ${props?.itemClasses}` }>
                            {!props?.hideSVG && <div className="flex justify-center items-center mb-4 h-48 bg-gray-300">
                            <svg className="w-12 h-12 text-gray-200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor" viewBox="0 0 640 512"><path d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"/></svg>
                            </div>}
                            <div className="h-2.5 bg-gray-200 xl:w-48 w-32 mb-4"></div>
                            <div className="h-6 bg-gray-200 mb-2.5"></div>
                            <div className="h-2 bg-gray-200 mb-2.5"></div>
                            <div className="h-2 bg-gray-200"></div>
                            <div className="flex items-center mt-4 space-x-3">
                            <div className="w-full">
                                <div className="h-8 border border-gray-200 w-full mb-2"></div>
                            </div>
                            </div>
                        </div>

                )
                })}
            </div>
            }
            {props?.isVideoList &&
                <>
                <div className="responsive flex flex-wrap md:justify-between justify-around gap-y-14 my-24">
                  {Array.from({length: props?.itemsPerPage}, (_:any,index:number)=>{
                    return(

                          <div key={index} role="status" className="flex justify-center items-center w-[45%] h-56 bg-gray-300 animate-pulse">
                            <svg className="w-12 h-12 text-gray-200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor" viewBox="0 0 384 512"><path d="M361 215C375.3 223.8 384 239.3 384 256C384 272.7 375.3 288.2 361 296.1L73.03 472.1C58.21 482 39.66 482.4 24.52 473.9C9.377 465.4 0 449.4 0 432V80C0 62.64 9.377 46.63 24.52 38.13C39.66 29.64 58.21 29.99 73.03 39.04L361 215z"/></svg>
                          </div>

                    )
                  })}
                </div>
              </>
            }
            {props?.isGallery &&
            <>
              <div className="responsive grid gap-y-11 grid-cols-1 lg:grid-cols-2 lg:gap-x-14 lg:gap-y-14 my-24">
                {Array.from({length: 2}, (_:any)=>{
                  return(
                          <div key={_} role="status" className="p-4 w-full border border-gray-200 shadow animate-pulse md:p-6">
                              <div className="flex justify-center items-center mb-4 h-48 bg-gray-300">
                              <svg className="w-12 h-12 text-gray-200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor" viewBox="0 0 640 512"><path d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"/></svg>
                              </div>
                              <div className="h-2.5 bg-gray-200 w-48 mb-4"></div>
                              <div className="h-6 bg-gray-200 mb-2.5"></div>
                              <div className="h-2 bg-gray-200 mb-2.5"></div>
                              <div className="h-2 bg-gray-200"></div>
                              <div className="flex items-center mt-4 space-x-3">
                              <div className="w-full">
                                  <div className="h-8 border border-gray-200 w-full mb-2"></div>
                              </div>
                              </div>
                          </div>

                  )
                })}
                </div>
                <div className="responsive flex animate-pulse p-4 gap-4 border shadow border-gray-200 md:p-6 my-24">
                  <div role="status" className="w-full lg:w-[80%]">
                      <div className="flex justify-center items-center mb-4 h-48 bg-gray-300">
                      <svg className="w-12 h-12 text-gray-200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor" viewBox="0 0 640 512"><path d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"/></svg>
                      </div>
                  </div>
                  <div>
                    <div className="h-11 bg-gray-200 w-48 mb-4"></div>
                    <div className="h-20 bg-gray-200 mb-2.5"></div>
                  </div>
                </div>
                <div className="responsive flex flex-row-reverse animate-pulse p-4 gap-4 border shadow border-gray-200 md:p-6 my-24">
                  <div role="status" className="w-full lg:w-[80%]">
                      <div className="flex justify-center items-center mb-4 h-48 bg-gray-300">
                      <svg className="w-12 h-12 text-gray-200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor" viewBox="0 0 384 512"><path d="M361 215C375.3 223.8 384 239.3 384 256C384 272.7 375.3 288.2 361 296.1L73.03 472.1C58.21 482 39.66 482.4 24.52 473.9C9.377 465.4 0 449.4 0 432V80C0 62.64 9.377 46.63 24.52 38.13C39.66 29.64 58.21 29.99 73.03 39.04L361 215z"/></svg>
                      </div>
                  </div>
                  <div>
                    <div className="h-11 bg-gray-200 w-48 mb-4"></div>
                    <div className="h-20 bg-gray-200 mb-2.5"></div>
                  </div>
                </div>
            </>
            }
            { props?.isCalendar &&
              <div className='mb-[130px] relative grid grid-cols-7 w-full place-items-center bg-[#F2F2F2] py-10 animate-pulse gap-y-10'>
              {Array.from({length: 7}, (_:any, index: number)=>{
                return(
                <div
                  className="w-[29px] h-[22px] md:w-[58px] md:h-[44px] bg-[#e4e4e4]"
                  key={index}
                  >

                </div>
                )
              })}
            </div>
            }
            { props?.isImg && <div  role="status"  className={` p-4 w-full border border-gray-200 shadow animate-pulse md:p-6  ${props?.itemClasses}` }>
              <div className="flex justify-center items-center mb-4 h-48 bg-gray-300">
                 <svg className="w-12 h-12 text-gray-200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor" viewBox="0 0 640 512"><path d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"/></svg>
              </div>
            </div>}
        </>
    )
}

export default Loading;